export const API = {

    Login: "/Dispatch/userLogin"
}